import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=dc43ae16&"
import script from "./addMaterial.vue?vue&type=script&lang=js&"
export * from "./addMaterial.vue?vue&type=script&lang=js&"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=dc43ae16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports